import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

/**
 * Interface & Utility
 */

export type Infix = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
export type Theme = "light" | "dark";

export type UIState = {
  theme: Theme;
  width: number;
  infix: Infix;
  touchable: boolean;
};

const getInfix = (): Infix => {
  const width = window.innerWidth;
  if (width < 576) return "xs";
  if (width < 768) return "sm";
  if (width < 992) return "md";
  if (width < 1200) return "lg";
  if (width < 1400) return "xl";
  return "xxl";
};
const isTouchable = () => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};
const getTheme = (): Theme => {
  const hour = new Date().getHours();
  if (hour >= 6 && hour < 18) return "light";
  return "dark";
};

/**
 * Store constructor
 */

const NAME = "ui";
const initialState: UIState = {
  theme: getTheme(),
  width: window.innerWidth,
  infix: getInfix(),
  touchable: isTouchable(),
};

/**
 * Actions
 */

export const setTheme = createAsyncThunk(
  `${NAME}/setTheme`,
  async (theme: Theme) => {
    return { theme };
  }
);

export const resize = createAsyncThunk(`${NAME}/resize`, async () => {
  const width = window.innerWidth;
  const infix = getInfix();
  return { width, infix };
});

/**
 * Usual procedure
 */

const slice = createSlice({
  name: NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    void builder
      .addCase(setTheme.fulfilled, (state, { payload }) => {
        console.log(payload, 7);
        void Object.assign(state, payload);
      })
      .addCase(
        resize.fulfilled,
        (state, { payload }) => void Object.assign(state, payload)
      ),
});

export default slice.reducer;
